import React from 'react';
import { ImSpinner8 } from 'react-icons/im';

interface BadgeIndicatorProps {
    quantity: number;
    className?: string;
    animated?: Boolean;
    loading?: Boolean;
}

const BadgeIndicator = ({
    quantity,
    className,
    animated = false,
    loading = false
}: BadgeIndicatorProps) => {

    return (
        <div className={`absolute w-full h-full flex items-center justify-center font-medium bg-gray-800 bg-opacity-0 rounded-t-lg ${className}`}>
            <span className={`bg-shopfood-required z-25 rounded-full w-6 h-6 md:w-7 md:h-7 flex items-center justify-center absolute -top-1 -right-1 md:-top-1.5 md:-right-1.5 ${animated && 'zoomInIcon'}`}>
                <span className="text-xs md:text-sm font-extrabold leading-none text-white">
                    {loading
                        ? <ImSpinner8 className="animate-spin" size={14} />
                        : quantity
                    }
                </span>
            </span>
            <span className={`bg-shopfood-required z-20 rounded-full w-6 h-6 md:w-7 md:h-7 flex items-center justify-center absolute -top-1 -right-1 md:-top-1.5 md:-right-1.5 ${animated && 'animate-ping'}`}></span>
        </div>
    );
};

export default BadgeIndicator;
